import React from 'react';

const SectionTitle = ({ background, titleCaption, title, description }) => {
  return (
    <div className="textWrap flex-col gap-32">
      {background && (
        <div className="background">
          <img src={background} alt="" />
        </div>
      )}

      <div className="titleWrap flex-col gap-24">
        <div className="accent flex-row gap-8">
          <span>{titleCaption || 'titleCaption'}</span>
        </div>
        <div className="title">
          <span>{title || 'title'}</span>
        </div>
      </div>
      {description && (
        <div className="description">
          <span>{description}</span>
        </div>
      )}
    </div>
  );
};
export default SectionTitle;
